import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Button from Ant Design

function Vegetabledetail({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [expandedRows, setExpandedRows] = useState({}); // State to manage visibility of data per shop

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the items table
  const itemColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Selling Price",
      dataIndex: "sellingPrice",
      key: "sellingPrice",
    },
    {
      title: "Daily Income",
      dataIndex: "dailyIncome",
      key: "dailyIncome",
    },
    {
      title: "Daily Purchase",
      dataIndex: "dailyPurchase",
      key: "dailyPurchase",
    },
    {
      title: "Morning Price",
      dataIndex: "morningPrice",
      key: "morningPrice",
    },
    {
      title: "Morning Sale",
      dataIndex: "morningSale",
      key: "morningSale",
    },
    {
      title: "Net Quantity",
      dataIndex: "netQuantity",
      key: "netQuantity",
    },
    {
      title: "Selling Income",
      dataIndex: "sellingIncome",
      key: "sellingIncome",
    },
    {
      title: "Purchase Price",
      dataIndex: "purchasePrice",
      key: "purchasePrice",
    },
    {
      title: "Purchase Cost",
      dataIndex: "purchaseCost",
      key: "purchaseCost",
    },
    {
      title: "Wastage",
      dataIndex: "wastage",
      key: "wastage",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="">Name: {item?.shop?.name}</h5>
                  <p>Working Days: {item?.shop?.workingDays}</p>

                  {/* Items Section */}
                  {item.items && item.items.length > 0 ? (
                    <div className="mt-4">
                      <h6 className="text-danger">Items:</h6>
                      <Table
                        dataSource={item.items}
                        columns={itemColumns}
                        pagination={false}
                        rowKey={(record, index) => index} // Use index as row key
                      />
                      {/* {item.items.length > 3 && (
                        <Button
                          onClick={() => setExpandedRows((prev) => ({
                            ...prev,
                            [index]: { items: !prev[index]?.items }
                          }))}
                          className="mt-2"
                        block>
                          {expandedRows[index]?.items ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <p className="text-muted">No items available</p>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="card text-center">
              <div className="card-body">
                <p className="text-muted">No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Vegetabledetail;
